var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Fillable, Path, PrimaryKey, UploadRestModel } from 'ng-rest-model';
var Sermon = /** @class */ (function (_super) {
    __extends(Sermon, _super);
    function Sermon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        PrimaryKey(),
        __metadata("design:type", Number)
    ], Sermon.prototype, "id", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Sermon.prototype, "date", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Sermon.prototype, "preacher", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Sermon.prototype, "title", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Sermon.prototype, "file", void 0);
    Sermon = __decorate([
        Path('sermons')
    ], Sermon);
    return Sermon;
}(UploadRestModel));
export { Sermon };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/classes/sermon.ts.pre-build-optimizer.js